import { render, staticRenderFns } from "./Expert2FieldReferenceList.vue?vue&type=template&id=9b7a64ae&scoped=true&"
import script from "./Expert2FieldReferenceList.vue?vue&type=script&lang=js&"
export * from "./Expert2FieldReferenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7a64ae",
  null
  
)

export default component.exports